import { render, staticRenderFns } from "./hgnd.vue?vue&type=template&id=0d975c0c&scoped=true&"
import script from "./hgnd.vue?vue&type=script&lang=js&"
export * from "./hgnd.vue?vue&type=script&lang=js&"
import style0 from "./hgnd.vue?vue&type=style&index=0&id=0d975c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d975c0c",
  null
  
)

export default component.exports